<div [id]="member.agoraUid" class="videoPlayer">
  <div class="video-meta">
    <mat-icon [svgIcon]="member.audio ? 'mic' : 'mic_off'"></mat-icon>
    <span>{{ member.displayName }}</span>
  </div>
  @if (!member.video) {
  <messaging-avatar class="avatar" [name]="member.picName" [initialsSize]="2" size="64" [src]="member.imageURL">
  </messaging-avatar>
  } @if (!member.video) {
  <div class="background-container"></div>
  }
</div>
